import React from 'react'
import styled from 'styled-components'

function ChatMessage({ text, user, timestamp, usrimg }) {
    console.log("here")
    console.log("Text in message: "+text+"  user is: "+user+" time stamp "+timestamp+" url "+usrimg);

    return (
        <Container>
            <UserAvatar>
                <img src={usrimg}></img>
            </UserAvatar>
            <MessageContent>
                <Name>
                    {user} 
                    <span> 
                    {new Date(timestamp.toDate()).toUTCString()} 
                    </span>
                </Name>

                <Text>
                  {text} 
                </Text>

            </MessageContent>


        </Container>
    )
}

export default ChatMessage

const Container = styled.div`
// background:orange;
min-height:48px;
display:flex;
padding: 10px 9px ;
align-items:center;

:hover{
  background:rgba(245, 245, 225,0.30);
}

`
const UserAvatar = styled.div`
width: 40px;
height: 40px;
border-radius: 6px;
overflow:hidden;
margin-right:12px;
img{
    width:100%;
}
`
const MessageContent = styled.div`
display:flex;
flex-direction:column;
`

const Name = styled.span`
font-weight:900;
font-size:15px;
line-height:1.4;
    span{
        margin-left:8px;
        font-weight:400;
        color: rgb(97,96,97);
        font-size:13px;
    }
`
const Text = styled.span`
    padding: 8px;
`